import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PushToVoteModal = ({ suggestion, onClose, onPushed }) => {
  const [text, setText] = useState('');
  const [pushing, setPushing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (suggestion) { setText(suggestion.suggestion || ''); setError(null); }
  }, [suggestion]);

  if (!suggestion) return null;

  const push = async () => {
    setPushing(true);
    setError(null);
    try {
      const r = await fetch(`${BACKEND_URL}/api/admin/suggestions/${encodeURIComponent(suggestion.created_at)}/push-to-vote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('beatseek_token') || ''}`
        },
        body: JSON.stringify({ text: text.trim() })
      });
      const d = await r.json();
      if (r.ok) { onPushed(); onClose(); }
      else setError(d.detail || 'Push failed');
    } catch (e) { setError('Network error'); }
    setPushing(false);
  };

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 10001, background: 'rgba(0,0,0,0.75)',
        backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        data-testid="push-to-vote-modal"
        style={{
          width: '100%', maxWidth: '440px',
          background: 'linear-gradient(160deg, #12122b 0%, #1a1a3e 100%)',
          border: '1px solid rgba(250, 204, 21, 0.35)', borderRadius: '14px', overflow: 'hidden'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.9rem 1rem', borderBottom: '1px solid rgba(250,204,21,0.2)' }}>
          <span style={{ color: '#facc15', fontWeight: 700, fontSize: '0.95rem' }}>📊 Push to Community Vote</span>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', cursor: 'pointer' }}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: '1rem' }}>
          <p style={{ color: '#9ca3af', fontSize: '0.8rem', margin: '0 0 10px' }}>
            This posts anonymously as "💡 Beatseeker Suggestion" — review the text and remove anything that could identify the submitter. Poll runs 7 days.
          </p>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            maxLength={500}
            data-testid="push-vote-text"
            style={{
              width: '100%', boxSizing: 'border-box', minHeight: '100px', padding: '10px',
              borderRadius: '8px', background: 'rgba(0,0,0,0.5)', resize: 'vertical',
              border: '1px solid rgba(250,204,21,0.3)', color: '#fff', fontSize: '0.87rem', fontFamily: 'inherit'
            }}
          />
          {error && <p style={{ color: '#ff6b6b', fontSize: '0.78rem', margin: '8px 0 0' }} data-testid="push-vote-error">{error}</p>}
          <button
            onClick={push}
            disabled={pushing || text.trim().length < 3}
            data-testid="push-vote-confirm-btn"
            style={{
              width: '100%', marginTop: '12px', padding: '11px', borderRadius: '8px', border: 'none',
              background: 'linear-gradient(135deg, #facc15, #eab308)', color: '#1a1a2e',
              fontWeight: 800, fontSize: '0.88rem', cursor: 'pointer', opacity: pushing ? 0.6 : 1
            }}
          >
            {pushing ? 'Pushing...' : '📊 Push to the Wall'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PushToVoteModal;
